import { styled } from '@mui/material'

export const FormWrapper = styled('div')`
  max-width: ${({ theme }) => theme.display.formMediumWidth}px;
  margin: auto;
`
